import React from 'react';
import clsx from 'clsx';
import Header from '../../components/Header/Header';
import Sidebar from '../../components/Sidebar/Sidebar';
import { Bar } from 'react-chartjs-2';
import { makeStyles } from '@material-ui/styles';
import SaveIcon from '@material-ui/icons/Save';
import InputLabel from '@material-ui/core/InputLabel';
import ReactToPdf from 'react-to-pdf';
import {
    IconButton,
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Select,
    MenuItem,
    Grid,

    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Divider,
    Switch,
    TextField,
    Typography,
    colors
} from '@material-ui/core';
import { get_overview_agency_report, get_agencies } from '../../api/API';
import moment from 'moment/moment.js'
import DatePicker from 'react-date-picker';
import { CSVLink } from "react-csv";
const useStyles = makeStyles(theme => ({
    root: {
        padding: '24px',
    },

}));

export default class BarChartAgency extends React.Component {


    constructor(props) {
        super(props);
        this.ref = React.createRef();
        this.colors = ["#faf13e", "#b8fa3e", "#3efa9f", "#21decb", "#3c8ae8", "#8438e0", "#e038cc", "#f0328b", "#eb2f4e"];

        var start_date = new Date();
        start_date.setDate(start_date.getDate() - 7);
        this.state = {
            csv_output: [],
            redraw: false,
            start_print: false,
            grand_total: 0,
            raw_data: [],
            properties_output: [],
            chart_option: {
                maintainAspectRatio: false,
                scales: {
                    yAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Value'
                        },
                        ticks: {
                            min: 0,
                            max: 10,
                            stepSize: 1
                        }
                    }]
                }
            },
            chartData: {},
            agencies: [],
            values: {
                agencies: "",
                metric: "appointments",
                date_from: moment().subtract(7, 'day').format("yyyy-MM-DD"),
                date_to: moment().format("yyyy-MM-DD"),
                appointment_type: "all"
            }
        };
        this.get_data();
        this.get_agencies_data();
    }
    handleChange(e) {
        this.setState({
            ...this.state,
            values: {
                ...this.state.values,
                [e.target.name]: e.target.value
            }
        }, () => {
            this.get_data();
        });

    }

    async get_agencies_data() {
        var currentObj = this;
        let agencies = await get_agencies();
        if (agencies) {
            currentObj.setState({
                ...this.state,
                agencies: agencies
            });
        }
    }

    parse_chart_data(data) {
        var labels = [];
        var datasets = [];
        var property_colors = {};
        var max_y_tick = 5;
        var total = 0;
        var property_dataset = {

        };
        for (var i = 0; i < data.length; i++) {
            labels.push(data[i].name);
            for (var j = 0; j < data[i].properties.length; j++) {
                var showroom = data[i].properties[j];
                if (property_dataset['a_' + showroom.property_id] == undefined) {
                    property_dataset['a_' + showroom.property_id] = {
                        values: {}
                    };
                }
                property_dataset['a_' + showroom.property_id].name = showroom.name;
                property_dataset['a_' + showroom.property_id].color = showroom.color;

                property_dataset['a_' + showroom.property_id].values['a_' + data[i].agency_id] = showroom.total;
                total += showroom.total;
                max_y_tick = max_y_tick > parseInt(showroom.total) ? max_y_tick : parseInt(showroom.total);
            }
        }


        var index = 0;
        for (var key in property_dataset) {
            var row_data = [];
            var row = property_dataset[key];
            for (var i = 0; i < data.length; i++) {
                var value = row.values['a_' + data[i].agency_id] ? row.values['a_' + data[i].agency_id] : 0;
                row_data.push(value);
            }
            datasets.push({
                label: row.name,
                backgroundColor: row.color,
                borderColor: row.color,
                borderWidth: 1,
                hoverBackgroundColor: row.color,
                hoverBorderColor: row.color,
                data: row_data
            });
            index++;
        };
        this.setState({
            ...this.state,
            chartData: {
                labels: labels,
                datasets: datasets
            },
            chart_option: {
                maintainAspectRatio: false,
                scales: {
                    yAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Value'
                        },
                        ticks: {
                            min: 0,
                            max: max_y_tick + 5,
                            stepSize: 1
                        }
                    }]
                }
            },
        });
    }
    async get_data() {
        console.log(this.state.values);
        var values = {
            ...this.state.values,
            date_from: moment(this.state.values.date_from).format("yyyy-MM-DD"),
            date_to: moment(this.state.values.date_to).format("yyyy-MM-DD")
        }
        var data = await get_overview_agency_report(values);
        if (data) {
            this.setState({
                ...this.state,
                raw_data: data.data
            });
            this.parse_chart_data(data.data);
            this.parse_table_data(data.data, data.properties)
        }
    }
    parse_table_data(data, properties) {
        var data_output = [];
        var grand_total = 0;
        for (var properties_i = 0; properties_i < properties.length; properties_i++) {
            var property_row = properties[properties_i];
            var temp_row = [property_row.name];
            var row_total = 0;
            for (var data_i = 0; data_i < data.length; data_i++) {
                var data_row = data[data_i];
                var cell_val = 'N/A';
                for (var data_property_i = 0; data_property_i < data_row['properties'].length; data_property_i++) {
                    if (data_row.properties[data_property_i].property_id == property_row.property_id) {
                        row_total += parseInt(data_row.properties[data_property_i].total);
                        grand_total += parseInt(data_row.properties[data_property_i].total);
                        cell_val = data_row.properties[data_property_i].total;
                        break;
                    }
                }
                temp_row.push(cell_val);
            }
            temp_row.push(row_total);
            data_output.push(temp_row);
        }

        this.setState({
            ...this.state,
            properties_output: data_output,
            grand_total: grand_total
        }, this.downloadCSV);
    }

    downloadCSV() {
        var export_data = [];
        var header = [''];
        this.state.raw_data.map((row) => {
            header.push(row.name);
        });
        header.push('Total');
        export_data.push(header);

        this.state.properties_output.map(row => {
            var data_row = [];
            row.map((cell) => {
                data_row.push(cell);
            });
            export_data.push(data_row);
        });
        this.setState({
            ...this.state,
            csv_output: export_data
        }, () => {
            console.log(this.state)
        }
        );
    }
    render() {
        return (
            <React.Fragment>
                <Header
                    classes={this.props.classes}
                    onSidebarOpen={this.props.handleSidebarOpen}
                />
                <Sidebar
                    classes={this.props.classes}
                    onClose={this.props.handleSidebarClose}
                    open={this.props.shouldOpenSidebar}
                    variant={this.props.isDesktop ? 'persistent' : 'temporary'}
                />
                <main className={this.props.classes.content}>
                    <div className={this.props.classes.toolbar} />
                    <br></br>

                    <div
                        {...this.props}
                        className={clsx(this.props.classes.root, this.props.className)}
                        style={{
                            height: "auto",
                            padding: 8
                        }}
                    >
                        <Card>
                            <CardHeader
                                action={
                                    <>
                                        <ReactToPdf
                                            targetRef={this.ref}
                                            filename={"Agency_Overview_" + this.state.values.date_from + "_" + this.state.values.date_to + ".pdf"}
                                            scale={0.8}
                                            x={2}
                                            y={0}
                                            onComplete={(() => {
                                                this.setState({
                                                    ...this.state,
                                                    start_print: false,
                                                    redraw: true
                                                })
                                            }).bind(this)}
                                        >
                                            {({ toPdf }) => (
                                                <IconButton
                                                    onClick={(() => {
                                                        window.scrollTo(0, 0);
                                                        this.setState({
                                                            ...this.state,
                                                            start_print: true,
                                                            redraw: true
                                                        }, () => {
                                                            setTimeout(toPdf, 2000);
                                                        });

                                                    }).bind(this)}
                                                >
                                                    <SaveIcon style={{ color: "black" }} />
                                                </IconButton>
                                            )}
                                        </ReactToPdf>
                                        <IconButton

                                        >
                                            <CSVLink
                                                data={this.state.csv_output}
                                                filename={"Agency_Overview_" + this.state.values.date_from + "_" + this.state.values.date_to + ".csv"}
                                            >
                                                <img style={{
                                                    width: 26
                                                }} src={require("../../assets/excel_icon.png")}></img>
                                            </CSVLink>
                                        </IconButton>
                                    </>
                                }
                                title="Agency Overview"
                            />
                            <Divider />
                            <CardContent className={useStyles.content}>
                                <div
                                    className="report_filter overview_filter"
                                >
                                    <div className="filter_field_wrapper">
                                        <InputLabel shrink id="metric_label">
                                            View
                                        </InputLabel>
                                        <Select
                                            labelId="metric_label"
                                            onChange={this.handleChange.bind(this)}
                                            name="metric"
                                            className="full_width"
                                            value={this.state.values.metric}
                                        >
                                            <MenuItem
                                                value="appointments">
                                                Appointments
                                            </MenuItem>
                                            <MenuItem
                                                value="pax">
                                                Guests
                                            </MenuItem>
                                        </Select>
                                    </div>
                                    <div className="filter_field_wrapper">

                                        <InputLabel shrink id="metric_label">
                                            Guest Type
                                        </InputLabel>

                                        <Select
                                            className="full_width"
                                            labelId="appointment_type"
                                            label="appointment_type"
                                            onChange={this.handleChange.bind(this)}
                                            name="appointment_type"
                                            value={this.state.values.appointment_type}
                                        >
                                            <MenuItem
                                                value="all">
                                                All
                                            </MenuItem>
                                            <MenuItem
                                                value="1">
                                                New Prospect
                                            </MenuItem>
                                            <MenuItem
                                                value="2">
                                                Prospect Revisit
                                            </MenuItem>
                                            <MenuItem
                                                value="3">
                                                Buyer Revisits
                                            </MenuItem>
                                        </Select>
                                    </div>
                                    <div className="filter_field_wrapper">
                                        <InputLabel shrink id="agency_label">
                                            Agencies
                                        </InputLabel>
                                        <Select
                                            className="full_width"
                                            labelId="agency_label"
                                            onChange={this.handleChange.bind(this)}
                                            name="agencies"
                                            value={this.state.values.agencies}
                                        >
                                            <MenuItem
                                                value="">

                                            </MenuItem>
                                            <MenuItem
                                                value="all">
                                                All
                                            </MenuItem>
                                            {
                                                this.state.agencies.map((agency) => (
                                                    <MenuItem key={agency.agency_id}
                                                        value={agency.agency_id}>
                                                        {agency.name}
                                                    </MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </div>
                                    <div className="filter_field_wrapper">
                                        <TextField
                                            type="date"
                                            name="date_from"
                                            className="full_width"
                                            label="From"
                                            onChange={this.handleChange.bind(this)}
                                            value={this.state.values.date_from}

                                        />
                                    </div>

                                    <div className="filter_field_wrapper">
                                        <TextField
                                            type="date"
                                            name="date_to"
                                            label="to"
                                            className="full_width"
                                            onChange={this.handleChange.bind(this)}
                                            value={this.state.values.date_to}

                                        />
                                    </div>


                                </div>
                                <div ref={this.ref} style={{
                                    width: this.state.start_print ? 900 : "auto"
                                }}>
                                    {this.state.start_print && (
                                        <div style={{
                                            marginBottom: 30,
                                        }}>
                                            <Grid container>
                                                <Grid item md={3}>
                                                    <img src={require("../../assets/logo_small.png")}></img>
                                                    <p>Showing date: {this.state.values.date_from} to {this.state.values.date_to}</p></Grid>
                                                <Grid item md={6} style={{
                                                    textAlign: 'center'
                                                }}>
                                                    <h1>Agency Overview</h1>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    )}
                                    <div style={{
                                        height: '60vh',
                                        maxHeight: '30vh'
                                    }}>
                                        <Bar
                                            redraw={this.state.redraw}
                                            width={this.state.start_print ? 900 : "auto"}
                                            height={this.state.start_print ? 200 : "auto"}
                                            options={{
                                                ...this.state.chart_option,
                                                maintainAspectRatio: false,
                                                devicePixelRatio: 2
                                            }} data={this.state.chartData}></Bar>

                                    </div>
                                    <div style={{
                                        width: "100%",
                                    }}>
                                        <Table width="100%" className="report_table" style={{ width: this.state.start_print ? "100% !important" : "auto", tableLayout: "fixed" }}>
                                            <TableHead>
                                                <TableRow >
                                                    <TableCell style={{
                                                        textAlign: "center",
                                                        backgroundColor: "black",
                                                        color: "white"
                                                    }}
                                                        colSpan={this.state.raw_data.length + 2}>Appointments</TableCell>

                                                </TableRow>
                                                <TableRow>
                                                    <TableCell></TableCell>
                                                    {this.state.raw_data.map((row) => (
                                                        <TableCell>{row.name}</TableCell>
                                                    ))}
                                                    <TableCell
                                                        className="bold section_2"
                                                    >Total</TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>

                                                {this.state.properties_output.map((row) => (
                                                    <TableRow>
                                                        {row.map((val) => (
                                                            <TableCell className="bold">{val}</TableCell>
                                                        ))}
                                                    </TableRow>
                                                ))}
                                                <TableRow>
                                                    <TableCell style={{ fontWeight: 'bold' }} colSpan={this.state.raw_data.length + 1}>
                                                        Total
                                                    </TableCell>
                                                    <TableCell style={{ fontWeight: 'bold' }}>{this.state.grand_total}</TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </div>
                                </div>
                            </CardContent>
                        </Card>
                    </div>
                </main>
            </React.Fragment >
        )
    }
}
